import { IconButton } from "@material-ui/core";
import React from "react";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import CreateDeploymentDialog from "./CreateDeploymentDialog";
import { UpdateDeploymentProps } from "./DeploymentDetails";
import { useAuthorization } from "../../authorizer/components/AuthorizationProvider";
import { REGION_GROUPS } from "../config/deploymentRegions";
import { TrimbleColors } from "legacy-components/TrimbleColors";

export interface DeploymentEditorRegionalProps {
  basePath?: string;
  resourceAppId?: string;
  version?: string;
  updateDeployment?: UpdateDeploymentProps;
  onDeploymentUpdated?: () => void;
}

export const DeploymentEditorRegional: React.FC<DeploymentEditorRegionalProps> = ({
  basePath = "",
  resourceAppId = "",
  version = "",
  updateDeployment,
  onDeploymentUpdated,
}) => {
  const [editDeployment, setEditDeployment] = React.useState<boolean>(false);
  const { isActionAllowed } = useAuthorization(
    "SERVICE",
    updateDeployment?.serviceId ? updateDeployment?.serviceId : ""
  );
  const canUpdate = isActionAllowed("update");

  return (
    <>
      <IconButton
        onClick={() => setEditDeployment(true)}
        disabled={
          updateDeployment?.deploymentStatus !== "DEPLOY_COMPLETED" || !canUpdate
        }
        style={{ color: TrimbleColors.Gray6 }}
        size="small"
      >
        <EditOutlinedIcon />
      </IconButton>
      {editDeployment && (
        <CreateDeploymentDialog
          open={editDeployment}
          onClose={() => setEditDeployment(false)}
          onSuccess={() => {
            setEditDeployment(false);
            updateDeployment?.refreshDeployments?.();
            onDeploymentUpdated?.();
          }}
          basePath={basePath}
          resourceAppId={resourceAppId}
          version={version}
          regionGroups={REGION_GROUPS}
          updateDeployment={updateDeployment}
        />
      )}
    </>
  );
};
